import { themeQuartz } from 'ag-grid-community'

/** The data grids' AG Grid theme (DataGridViewer, LargeCsvGrid): dark, based on AG Grid's Quartz. */
export const dataGridTheme = themeQuartz.withParams({
  backgroundColor: '#1c1c1e',
  foregroundColor: '#e4e4e7',
  headerBackgroundColor: '#252528',
  headerTextColor: '#a1a1aa',
  borderColor: 'rgba(255,255,255,0.08)',
  rowHoverColor: 'rgba(255,255,255,0.04)',
  selectedRowBackgroundColor: 'rgba(255,255,255,0.08)',
  cellTextColor: '#e4e4e7',
  oddRowBackgroundColor: '#1c1c1e',
  popupShadow: '0 4px 16px rgba(0,0,0,0.5)',
  columnBorder: true,
  wrapperBorderRadius: 0,
  headerFontSize: 13,
  fontSize: 13,
})
